// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"6ffe8b47","706":"6ffe8b47"}[chunkId] + ".css";
};